/// <amd-module name="Widgets/TeamMembersWidget/components/InviteAFriendComponent" />
import React = require("react");
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Button } from "VSSUI/Button";
import * as Resources from "Widgets/TeamMembersWidget/Resources";

interface InviteAFriendProps {
    userIsAdmin: boolean;
    onManageMembersClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export class InviteAFriendComponent extends VssComponent<InviteAFriendProps, {}> {
    public static DomClass_InviteAFriendContainer = "invite-a-friend-container";
    public static DomClass_InviteAFriendMessageContainer = "invite-a-friend-message-container";
    public static DomClass_InviteAFriendMessageAligner = "invite-a-friend-message-aligner";
    public static CSSClass_InviteAFriendMessage = "invite-a-friend-message";
    public static CSSClass_InviteAFriendButton = "invite-a-friend-button";

    private static selectCard(): number {
        return Math.floor(Math.random() * 5);
    }
    private cardId = InviteAFriendComponent.selectCard();

    public render(): JSX.Element {
        return (
            <div className={InviteAFriendComponent.DomClass_InviteAFriendContainer}>
                <img src={this.getInviteAFriendImage(this.cardId)} />
                <div className={InviteAFriendComponent.DomClass_InviteAFriendMessageContainer}>
                    <div className={InviteAFriendComponent.DomClass_InviteAFriendMessageAligner}>
                        <div className="invite-a-friend-message">{this.getInviteAFriendMessage(this.cardId, this.props.userIsAdmin)}</div>
                        {this.props.userIsAdmin && this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }

    private renderButton(): JSX.Element {
        return (
            <Button
                className={InviteAFriendComponent.CSSClass_InviteAFriendButton}
                onClick={this.props.onManageMembersClick}
                primary
                text={Resources.InviteAFriend}
            />
        );
    }

    private getInviteAFriendImage(cardId: number): string {
        return getAssetLocation(this.context.pageContext, `ms.vss-dashboards-web/team-members-widget-content/images/teamMembers-${cardId + 1}.png`);
    }

    private getInviteAFriendMessage(cardId: number, isAdmin: boolean): string {
        if (!isAdmin) {
            return Resources.NonAdminNoMembersMessage;
        }
        const imageCaptions: string[] = [
            Resources.Message_Caption_1,
            Resources.Message_Caption_3,
            Resources.Message_Caption_2,
            Resources.Message_Caption_2,
            Resources.Message_Caption_2
        ];
        return imageCaptions[cardId];
    }
}
